
export enum StatusCodes {
    OK = 200,
    DEVICE_VERIFICATION = 210,
    RESET_PASSWORD = 211,
    TWO_FACTOR = 212,
    DEVICE_VERIFICATION_NT = 213,
    DEVICE_VERIFICATION_EMAIL_SENT = 214
}
